"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = void 0;
var models_1 = require("./models");
var authorization_1 = require("./services/authorization");
var container_1 = require("./services/container/container");
var CollectionsSdkError_1 = require("./services/http/CollectionsSdkError");
Object.defineProperty(exports, "CollectionsSdkErrorNames", { enumerable: true, get: function () { return CollectionsSdkError_1.CollectionsSdkErrorNames; } });
function factory(options) {
    if (options === void 0) { options = {}; }
    options.transport && container_1.setTransport(options.transport);
    options.Promise && container_1.setPromise(options.Promise);
    options.apiUrl && container_1.setApiUrl(options.apiUrl);
    options.siteToken && container_1.setSiteToken(options.siteToken);
    return {
        Collection: models_1.Collection,
        Item: models_1.Item,
        authorize: authorization_1.authorize,
        logout: authorization_1.logout,
    };
}
exports.factory = factory;
//# sourceMappingURL=index.js.map